<template>
  <a-card title="Revenue Per-Month" :bordered="false">
    <a-skeleton :loading="loading" active>
      <chart-value :chart-data="chartData" :options="options"></chart-value>
    </a-skeleton>
  </a-card>
</template>

<script>
import ChartValue from "./chart-value";

export default {
  name: "chart-value-container",
  components: {ChartValue},
  props: {
    uri: {
      type: String,
      default: null
    }
  },
  data: () => ({
    loading: false,
    items: []
  }),
  mounted() {
    this.getItems()
  },
  methods: {
    getItems() {
      this.loading = true
      this.$http.get(this.uri !== null ? this.uri : this.routeUri('hyperion.transaction.summary.value'))
        .then(res => (this.items = res.data))
        .catch(err => this.handleXhrError(err))
        .finally(() => this.loading = false)
    }
  },
  computed: {
    chartData() {
      const labels = this.items.map(item => this.moment().month(item.month - 1).format("MMM")+' '+item.year)

      const value = {
        label: 'Revenue',
        data: this.items.map(item => item.price),
        fill: false
      }

      return {
        labels: labels,
        datasets: [value]
      }
    },
    options() {
      const currency = (value) => this.currency(value)
      return {
        plugins: {
          colorschemes: {
            scheme: "brewer.Paired6"
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              offsetGridLines: true
            },
            ticks: {
              stepSize: 1000000000,
              callback: function(value, index, values) {
                return currency(value);
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              return label + currency(tooltipItem.yLabel)
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
